import axios from 'axios';

export const fetchAllScheduledIrrigationEvents = async () => {
  return await axios.get('/api/schedule/irrigation/');
};

export const fetchBlockSchedule = async (blockId) => {
  return await axios.get(`/api/schedule/block/${blockId}/`);
};

export const createScheduledIrrigationEvent = async ({ start_date, stop_date, block }) => {
  return await axios.post(
    '/api/schedule/irrigation/',
    {
      start_date,
      stop_date,
      block,
    },
  );
};

export const createOverride = async ({ sensorType, sensorIdentifier, state }) => {
  return axios.post(
    `/api/sensors/${sensorType}/override/create/`,
    {
      sensorType,
      sensorIdentifier,
      state,
    },
  );
};

export const endOverride = async ({ sensorType, sensorIdentifier }) => {
  return axios.post(
    `/api/sensors/${sensorType}/override/end/`,
    {
      sensorType,
      sensorIdentifier,
    },
  );
};

export const updateScheduledIrrigationEvent = async ({ id, start_date, stop_date, block }) => {
  return await axios.put(
    'api/schedule/irrigation/' + id + '/',
    {
      start_date,
      stop_date,
      block,
    },
  );
};

export const deleteScheduledIrrigationEvent = async ({ id }) => {
  return await axios.delete(
    'api/schedule/irrigation/' + id + '/',
  );
};